import { createSlice } from '@reduxjs/toolkit';
import authStorage from '../../utils/authStorage';

export const SESSION_KEYS = ['token', 'roles', 'serviceAccess', 'is_gsc_optional', 'is_super_login', 'bbsCmsHandshake'];

export const clearSessionStorage = () => {
  SESSION_KEYS.forEach((key) => authStorage.remove(key));
};

const defaultServiceAccess = {
  accessBuildBackLink: false,
  accessArticleGeneration: false,
  accessInfluencerDb: false,
  accessReviewPromotion: false,
  isCreditConsidered: 0,
  bbsCmsUser: false,
};

const storedServiceAccess = authStorage.getJSON('serviceAccess', null);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: authStorage.get('token') || null,
    userInfo: null,
    serviceAccess: storedServiceAccess
      ? { ...defaultServiceAccess, ...storedServiceAccess }
      : { ...defaultServiceAccess },
  },
  reducers: {
    loginSuccess: (state, action) => {
      const { token, service_access, userInfo } = action.payload;
      state.token = token ?? null;
      state.userInfo = userInfo ?? null;
      state.serviceAccess = service_access ?? defaultServiceAccess;
      if (token) {
        authStorage.set('token', token);
      }
      if (service_access) {
        authStorage.setJSON('serviceAccess', service_access);
      }
      if (userInfo?.is_gsc_optional !== undefined) {
        authStorage.set('is_gsc_optional', userInfo.is_gsc_optional);
      }
    },
    updateUserInfo: (state, action) => {
      state.userInfo = action.payload;
      const { service_access, is_gsc_optional } = action.payload;
      if (service_access) {
        state.serviceAccess = service_access;
        authStorage.setJSON('serviceAccess', service_access);
      }
      if (is_gsc_optional !== undefined) {
        authStorage.set('is_gsc_optional', is_gsc_optional);
      }
    },
    logout: (state) => {
      state.token = null;
      state.userInfo = null;
      state.serviceAccess = { ...defaultServiceAccess };
      clearSessionStorage();
    },
  },
});

export const { loginSuccess, updateUserInfo, logout } = authSlice.actions;
export const selectToken = (state) => state.auth.token;
export const selectIsAuthenticated = (state) => Boolean(state.auth.token);
export const selectUserInfo = (state) => state.auth.userInfo;
export const selectUserProfile = (state) => state.auth.userInfo?.user ?? null;
export const selectAccountInfo = (state) => state.auth.userInfo?.account_info ?? null;
export const selectServiceAccess = (state) => state.auth.serviceAccess;
export default authSlice.reducer;
